import { defineComponent as C, ref as g, inject as s, watchEffect as _, computed as E, createElementBlock as k, openBlock as c, Fragment as M, createBlock as u, createCommentVNode as p, createVNode as N, unref as i, normalizeProps as h, guardReactiveProps as P } from "vue";
import { PersonalizationService as S, TemplateAnnotationsService as b, Constants as x } from "@magnolia/frontend-helpers-base";
import m from "./vue-editor4.js";
import B from "./vue-editor7.js";
const z = /* @__PURE__ */ C({
  name: "EditableComponent",
  __name: "EditableComponent",
  props: {
    content: {},
    index: {}
  },
  setup(f) {
    const t = f, a = g(), l = s("config") || { componentMappings: {} }, n = s(
      "templateAnnotations"
    );
    _(() => {
      const e = n ? S.getSelectedVariant(
        t.content || void 0,
        n.value
      ) : t.content, o = b.generateMissingAreas(
        e,
        (n == null ? void 0 : n.value) || {}
      );
      a.value = o;
    });
    const v = () => {
      var e, o;
      return t.content && ((o = n == null ? void 0 : n.value) == null ? void 0 : o[(e = t.content) == null ? void 0 : e["@path"]]) || "";
    }, r = E(() => v()), d = (e) => a.value ? B.mgnlRender(
      a.value,
      e,
      l.componentMappings,
      l.fallbackComponent,
      void 0,
      t.index
    ) : null;
    return (e, o) => (c(), k(M, null, [
      r.value ? (c(), u(i(m), {
        key: 0,
        annotation: r.value,
        "should-refresh": !0
      }, null, 8, ["annotation"])) : p("", !0),
      N(d, h(P(e.$attrs)), null, 16),
      r.value ? (c(), u(i(m), {
        key: 1,
        annotation: i(x).END_COMPONENT_COMMENT
      }, null, 8, ["annotation"])) : p("", !0)
    ], 64));
  }
});
export {
  z as default
};
//# sourceMappingURL=vue-editor5.js.map
